import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { CheckInEntryMethod, CustomerCheckIn, getCheckInEntryMethodDisplay } from '../../../../../../../../../models/customer';
import { dateStringFromISO8601, timeStringFromISO8601 } from '../../../../../../../../../utils';
import { CheckInService } from '../../../../../../../../../services/check-in/check-in.service';
import { CheckIn } from '../../../../../../../../../models/check-in';
import { CheckInAlertsModalComponent } from '../check-in-alerts-modal/check-in-alerts-modal.component';
import { CustomerService } from '../../../../../../../../../services/customer/customer.service';
import { LocationService } from '../../../../../../../../../services/location/location.service';

@Component({
  selector: 'app-check-in-detail-modal',
  templateUrl: './check-in-detail-modal.component.html',
  styleUrls: ['./check-in-detail-modal.component.css']
})
export class CheckInDetailModalComponent implements OnInit {

  @Input() checkInId: number;
  @Input() checkInEditedCallback: () => undefined;

  public checkIn: CheckIn;
  public selectedLocationId: number;

  public editingCheckInLocation = false;

  public loadingCheckIn = true;
  public loadingEditLocation = false;
  public loadingConvertToPaidEntry = false;

  public successMessage = '';
  public errorMessage = '';
  public checkInNotFound = false;
  public serverError: number = null;

  public CheckInEntryMethod = CheckInEntryMethod;
  public getCheckInEntryMethodDisplay = getCheckInEntryMethodDisplay;
  public dateStringFromISO8601 = dateStringFromISO8601;
  public timeStringFromISO8601 = timeStringFromISO8601;

  constructor(
    public activeModal: NgbActiveModal,
    public locationService: LocationService,
    private modalService: NgbModal,
    private checkInService: CheckInService
  ) {}

  ngOnInit() {
    this.loadCheckIn();
  }

  public handleEditLocation() {
    this.loadingEditLocation = true;

    this.successMessage = '';
    this.errorMessage = '';

    this.checkInService
      .editCheckInLocation(this.checkInId, this.selectedLocationId)
      .then(() => {
        this.successMessage = 'Check-in location updated successfully.';
        this.loadCheckIn();
        this.checkInEditedCallback();
        this.editingCheckInLocation = false;
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingEditLocation = false; });
  }

  public handleConvertToPaidEntry(bypassAlerts: boolean) {
    this.loadingConvertToPaidEntry = true;

    this.successMessage = '';
    this.errorMessage = '';

    this.checkInService
      .convertFreeEntryToCheckIn(this.checkInId, bypassAlerts)
      .then(() => {
        this.successMessage = 'Check-in successfully converted to paid entry.';
        this.loadCheckIn();
        this.checkInEditedCallback();
      })
      .catch(reason => {
        const errorType = reason.error.error;
        if (errorType === 'check_in_alerts') {
          const checkInAlerts = reason.error.alerts;
          const modalRef = this.modalService.open(CheckInAlertsModalComponent);
          modalRef.componentInstance.alerts = checkInAlerts;
          modalRef.componentInstance.checkInAnywayCallback = () => {
            this.handleConvertToPaidEntry(true);
          };
        }
        else if (errorType === 'no_entry_method') {
          this.errorMessage = 'Customer has no active entry method.';
        }
        else if (errorType === 'check_in_not_free_entry') {
          this.errorMessage = 'Check-in has already been converted to free entry.';
          this.loadCheckIn();
        }
      })
      .finally(() => { this.loadingConvertToPaidEntry = false; });
  }

  public isLoading() {
    return (
      this.loadingCheckIn ||
      this.loadingConvertToPaidEntry
    );
  }

  private loadCheckIn() {
    this.loadingCheckIn = true;

    this.checkInService
      .getCheckIn(this.checkInId)
      .then(checkIn => {
        this.checkIn = checkIn;
        this.selectedLocationId = this.checkIn.location_id;
      })
      .catch(reason => {
        if (reason.status === 404) {
          this.checkInNotFound = true;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingCheckIn = false; });
  }

}
